import OrganicFlag from 'utils/organic_flag'

class SaveOrganicFlag {
  static async init () {
    return OrganicFlag.save()
  }
}

export default SaveOrganicFlag
